// #region Imports
import Navbar from "../components/Navbar"
import Rotator from "../components/Dashboard/Rotator"
import DashboardButton from "../components/Dashboard/DashboardButton"
import ArchivePopUp from "../components/Dashboard/ArchivePopUp"
import ProjectPopUp from "../components/Project/ProjectPopUp"
import BottomBar from "../components/Navbar/BottomBar"

import {
	motion,
	useScroll,
	useTransform
} from "framer-motion"

import {
	ReactLenis,
	useLenis
} from "@studio-freight/react-lenis"

import {
	useEffect,
	useRef,
	useState
} from "react"

import {
	useWindowSize
} from "../utils/useWindowSize"

import experience from "../content/data/experince.json"
import community from "../content/data/community.json"
import projects from "../content/data/project.json"
import mentorship from "../content/data/mentorship.json"
import awards from "../content/data/awards.json"
// #endregion


const dashboardSections = [
	{
		index: 0,
		title: "EXPERIENCE",
		data: experience,
		pillars: 6,
	},
	{
		index: 1,
		title: "COMMUNITY",
		data: community,
		pillars: 8,
	},
	{
		index: 2,
		title: "AWARDS",
		data: awards,
		pillars: 5,
	},
	{
		index: 3,
		title: "MENTORSHIP",
		data: mentorship,
		pillars: 14,
	},
	{
		index: 4,
		title: "PROJECTS",
		data: projects,
		pillars: 10,
	},
];


function Dashboard() {

	const [width] = useWindowSize()
	const ref = useRef(null)

	const [activeSection, setActiveSection] = useState(null)
	const [activeProject, setActiveProject] = useState(null)

	const lenis = useLenis()

	const { scrollYProgress } = useScroll({
		target: ref,
	})

	const smallProgress = useTransform(
		scrollYProgress,
		[0, 1],
		[0.7, 1]
	)

	const isLarge = width > 1035

	const scrollY = isLarge
		? scrollYProgress
		: smallProgress

	const textOpacity = useTransform(
		scrollYProgress,
		[0, 0.12],
		[1, 0]
	)

	const backgroundColor = useTransform(
		scrollYProgress,
		[0.5, 0.6],
		["#F4F9FF", "#000000"]
	)

	const opacity = useTransform(
		scrollY,
		[0.6, 0.8],
		[0, 1]
	)

	const pillarOpacity = useTransform(
		scrollY,
		[0.9, 1],
		[0, 1]
	)

	const borderColor = useTransform(
		scrollY,
		[0.9, 1],
		["#5BA1E7", "#000"]
	)


	// #region Popup State

	const popupOpen = Boolean(activeSection || activeProject)

	const openSection = (section) => {
		setActiveProject(null)
		setActiveSection(section)
	}

	const openProject = (project) => {
		setActiveProject(project)
	}

	const closeProject = () => {
		setActiveProject(null)
	}

	const closeSection = () => {
		setActiveProject(null)
		setActiveSection(null)
	}

	// #endregion


	// #region Popup Scroll Lock

	useEffect(() => {
		if (!lenis) return

		if (popupOpen) {
			lenis.stop()
		} else {
			lenis.start()
		}

		return () => {
			lenis.start()
		}
	}, [popupOpen, lenis])

	// #endregion


	return (
		<ReactLenis
			className="home"
			options={{
				smoothWheel: true,
				lerp: 0.05,
				easing: (t) =>
					Math.min(
						1,
						1.001 - Math.pow(2, -10 * t)
					),
			}}
			root={true}
		>

			<motion.main
				ref={ref}
				style={{ backgroundColor }}
				className="
					h-[450vh]
					small:h-[200vh]
					flex flex-col items-center
					bg-black
					small:pt-32
				"
			>

				<Navbar />


				<h2 className="fixed z-0 bottom-20 opacity-25">
					Scroll down
				</h2>


				<Rotator
					scrollY={scrollY}
				/>


				{/* DASHBOARD */}

				{!popupOpen && (
					<motion.div
						className="
							w-screen h-screen
							grid grid-cols-9 grid-rows-8
							gap-4 p-5
							sticky top-0
							small:h-[90vh]
							small:grid-cols-9
							small:grid-rows-8
							small:gap-3
							small:p-3
						"
						style={{
							opacity
						}}
					>

						{dashboardSections.map((section) => (
							<DashboardButton
								key={section.index}
								index={section.index}
								title={section.title}
								data={section.data}
								pillars={section.pillars}
								pillarOpacity={pillarOpacity}
								borderColor={borderColor}
								opacity={opacity}
								onOpen={() => openSection(section)}
							/>
						))}

					</motion.div>
				)}


				{!isLarge && (
					<motion.p
						className="
							sticky large:hidden
							text-[10vw]
							left-[5%] bottom-[50%]
							tracking-tightest
							text-left z-20
							w-[80vw] leading-none
							italic font-luimp font-[300]
						"
						style={{
							opacity: textOpacity
						}}
					>
						EVERYTHING I’VE BUILT ALONG THE WAY
					</motion.p>
				)}


				<BottomBar />


				{/* ARCHIVE POPUP */}
				{activeSection && !activeProject && (
                    <ArchivePopUp
                        activeSection={activeSection}
                        onClose={closeSection}
                        onProjectOpen={openProject}
                    />
                )}


				{/* PROJECT POPUP */}
				{activeProject && (
					<ProjectPopUp
						project={activeProject}
						isOpen={true}
						setIsOpen={closeProject}
					/>
				)}

			</motion.main>

		</ReactLenis>
	)
}


export default Dashboard